<template>
  <div class="directoryBox">
    <horizontalDirectory v-if="isOld === true" ref="horizontalDirectory"></horizontalDirectory>
    <treeLevelDirectory v-if="isOld === false" ref="treeLevelDirectory"></treeLevelDirectory>
  </div>
</template>

<script>
import { mapState } from "vuex";
import horizontalDirectory from "./components/horizontalDirectory.vue";
import treeLevelDirectory from "./components/treeLevelDirectory.vue";
import service from "@/CommonDP/service/folder-service";
import { beforePrjId } from "@/CommonDP/index.js";
export default {
  name: "DirectoryMaintenance",
  components: { horizontalDirectory, treeLevelDirectory },
  data() {
    return {
      isOld: null,
      allowCheck: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    prjId() {
      return this.prjInfo.prjId;
    }
  },
  mounted() {
    beforePrjId(this.beforePage, this);
    this.queryJudgeIsUseNewFolder();
  },
  async beforeRouteLeave(to, from, next) {
    try {
      await this.beforePage();
      next();
    } catch (error) {
      next(false);
    }
  },
  methods: {
    async beforePage() {
      // 第一次允许跳转后,后续不再拦截
      if (this.allowCheck) return;
      const checkSave = this.isOld ? this.$refs.horizontalDirectory?.checkSave() : this.$refs.treeLevelDirectory?.checkSave();
      if (checkSave) return;
      await this.$confirm("当前页面尚有未保存的修改，是否继续跳转?", "提示");
      this.allowCheck = true;
    },
    async queryJudgeIsUseNewFolder() {
      try {
        const res = await service.dynamicJudgeIsUseNewFolder(this.prjId);
        this.isOld = !res.data; // false的时候用旧的
        this.$store.dispatch("setJudgeIsUseNewFolder", res.data);
      } catch (err) {
        this.$store.dispatch("setJudgeIsUseNewFolder", false);
      }
    },
    queryfabutips() {
      this.$parent.queryfabutips("2");
    },
    fabutipsshowFu() {
      this.$parent.fabutipsshow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.directoryBox {
  height: 100%;
  width: 100%;
}
</style>
